//import { WorkCentreSummaryTableData } from './WorkCentreSummary.types'
import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import { WorkCentreServerData } from './WorkCentreSummary.types'
import { WORKCENTRE_STATUS_FETCH_TIMEOUT } from 'Common/Constants/Constants'

const fetchWorkcentreStatus = async (planId: string) => {
  const { data } = await request({
    url: `/plan/${planId}/workcentre-run-status`,
    method: 'get',
  })
  return data
}

export const useWorkcentreStatus = (planId: string) => {
  return useQuery(
    ['workcentre-plan', planId],
    () => fetchWorkcentreStatus(planId),
    {
      select: (data) => {
        if (data?.data) {
          return data.data.map((workcentreRow: WorkCentreServerData) => {
            return {
              workCentre: workcentreRow.code,
              status: workcentreRow.status,
              sourceSite: workcentreRow.siteLabel
                ? workcentreRow.siteLabel
                : workcentreRow.siteKey,
              workCentreKey: workcentreRow.workCentreKey,
              planId: workcentreRow.PartitionKey,
              siteKey: workcentreRow.siteKey,
            }
          })
        }
        return []
      },
      cacheTime: 0,
      refetchInterval: WORKCENTRE_STATUS_FETCH_TIMEOUT,
    }
  )
}

const fetchWorkcentreList = async (planId: string) => {
  const { data } = await request({
    url: `/plan/${planId}/workcentre-list`,
    method: 'get',
  })
  return data
}

export const useWorkcentreList = (planId: string, enabled = true) => {
  return useQuery(
    ['workcentre-list', planId],
    () => fetchWorkcentreList(planId),
    {
      select: (data) => data,
      enabled: enabled,
    }
  )
}

const fetchPublishedWorkcentres = async (planId: string) => {
  const { data } = await request({
    url: `/system-of-records/plan/${planId}/published-workcentres`,
    method: 'get',
  })
  return data
}

export const usePublishedWorkcentres = (planId: string) => {
  return useQuery(
    ['sor', 'published-workcentres', planId],
    () => fetchPublishedWorkcentres(planId),
    {
      select: ({ data }) => data,
    }
  )
}
